module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_attività-small-7eb3b281bd500696018a2c88ba86d3a0.png";